module.exports = __webpack_public_path__ + "first-500-signature.jpg?462cae20510372b1d817aeb335c17f6d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/first-500-signature.jpg
// module id = 547
// module chunks = 0